<template>
  <div>
    <div class="greet">
      {{`Welcome back, ${id()}`}}
    </div>

  </div>
</template>

<script>
  import {getId} from "@/api";
  import FileUploader from "@/components/FileUploader";

  export default {
    name: "Main",
    components: {FileUploader},
    methods: {
      id() {
        return getId()
      }
    }
  }
</script>

<style scoped>
  .greet {
    font-size: 36px;
    margin: 20px;
  }
</style>